import { ValidateEmail } from "@/api/forms";
import { api } from "@/forms/api";
import { backendErrors } from "./common";

export const CRYPTO_FORM_STEPS = {
  FIRST_STEP: "FIRST_STEP",
  SECOND_STEP: "SECOND_STEP",
  THANK_YOU_STEP: "THANK_YOU_STEP",
  VERIFY_STEP: "VERIFY_STEP",
  LOGIN_STEP: "LOGIN_STEP",
  RESTORE_STEP: "RESTORE_STEP",
  CONFIRM_STEP: "CONFIRM_STEP",
  ONE_TIME_PASSWORD_STEP: "ONE_TIME_PASSWORD_STEP"
};

export const cryptoFirstStep = async (userData: ValidateEmail) => {
  const { data: validateDate } = await api.forms.validateEmail(userData);

  if (validateDate.errors) {
    throw { errors: backendErrors(validateDate.errors) };
  }

  if (!validateDate.success) {
    // new account
    return {
      next: CRYPTO_FORM_STEPS.SECOND_STEP,
      data: userData
    };
  }

  throw {
    code: "email_exists"
  };
};

export const cryptoSecondStep = async (data: any) => {
  const { data: signupData } = await api.forms.signUpDemoUser(data);

  if (!signupData.success) {
    throw { errors: backendErrors(signupData.errors || {}) };
  }

  const { data: thankYouData } = await api.forms.demoTyPage({
    account_id: signupData.account_id,
    platform: signupData.platform,
    user_id: signupData.id
  });

  return {
    next: CRYPTO_FORM_STEPS.THANK_YOU_STEP,
    data: { ...thankYouData, ...signupData }
  };
};
